<div mat-dialog-content>
<p translate>datacenter.do-you-want-remove</p>
</div>
<div mat-dialog-actions align="end">
	<button type="button" class="save-view-button" mat-button color="primary" (click)="close()"><span class="save-view-button-name" translate>global.no</span></button>
	<button type="button" class="save-view-button" mat-button color="primary" (click)="save()" cdkFocusInitial><span class="save-view-button-name" translate>global.yes</span></button>
</div>